import React from "react";
import "./RefreshConfirmationModal.scss";

const RefreshConfirmationModal = ({
  open,
  title,
  message,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <div className="confirmation-overlay">
      <div className="confirmation-modal">
        <h3>{title}</h3>

        <p>{message}</p>

        <div className="confirmation-actions">
          <button className="btn-cancel" onClick={onCancel}>
            Cancel
          </button>

          <button className="btn-clear" onClick={onConfirm}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefreshConfirmationModal;